import * as Drawing from '../const';

export const standardPalette = {
  N: '#0d81fc', // custom blue
  F: '#13efef', // custom cyan
  Cl: '#25d681', // custom green
  Br: '#ad7f58', // brown9
  I: '#8e4ec6', // purple9
  O: '#ff2229', // custom red
  P: '#f76b15', // orange9
  S: '#ffdc00', // yellow10
};

export function setColors(mol, drawnMol, palette = standardPalette, selected) {
  if (selected.length > 0) {
    for (const key of Object.keys(drawnMol.atoms)) {
      drawnMol.atoms[key].color = 'black';
    }
    for (const key of selected) {
      drawnMol.atoms[key].color = Drawing.SELECT_COLOR;
      drawnMol.atoms[key].selected = true;
    }
  } else {
    for (const key of Object.keys(drawnMol.atoms)) {
      drawnMol.atoms[key].color = palette[mol.atoms[key].element] || 'black';
    }
  }

  for (const [key, atom] of Object.entries(mol.atoms)) {
    const { preview, color = Drawing.DEFAULT_CHANGE_COLOR } = atom;

    if (preview && color) {
      drawnMol.atoms[key].color = color;
    }
  }

  for (const [key, bond] of Object.entries(mol.bonds)) {
    const { preview, color = Drawing.DEFAULT_CHANGE_COLOR } = bond;

    if (preview && color) {
      drawnMol.bonds[key].color = color;
    }
  }
}
